var Node = require('../hierarchy/frResultNode');


module.exports = Node.extend({


    defaults: function() {

        var base = _.result( Node.prototype,  'defaults' );

        return _.extend( {}, base, {

            nodeType: 'PAGE',

            rowLevel: 2,
            pageId: null,
            pageNumber: null, // want to print in the grid
            isCurrentPage: false

        });

    },

    // TODO: share with PageTree -- Page Result
    updateIsCurrentPage: function( pageNumber ) {

        this.set( 'isCurrentPage', pageNumber === this.get('pageNumber') );

    }



});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/searchHierarchy/SearchPageResult.js
 ** module id = 673
 ** module chunks = 0
 **/